import { provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
/// <reference types="@angular/localize" />

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.sentryDSN) {
    Sentry.init({
        dsn: environment.sentryDSN,
        sendDefaultPii: true,
        environment: environment.name,
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch(err => console.error(err));
